import {
    DataFlowDatasetSettings,
    DatasetFormatType
} from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { Metamodel } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { DataFlowExpression } from 'app/model/dataflow/dataflowexpression';
import { StringDataFlowType } from 'worker/app-workers/shared/models/dataflow-datatype';
import { zendeskEntityOptions } from 'app/shared/utils/connector-metadata-static-consts';

@Metamodel.model({
    name: adfModelTypeMap.zendesk.dataflowSettings
})
export class ZendeskSettings  extends DataFlowDatasetSettings {
    @Metamodel.attribute({})
    public entity: DataFlowExpression;

    public getDatasetType(): string {
        // for now, Zendesk only support inline mode, it does not have dataset
        return undefined;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.Zendesk;
    }

    public getIconClass(): string {
        return 'i-100x100-zendesk';
    }

    public getSubFormat(): string {
        return undefined;
    }

    public initialize(subFormat: string): void {
        this.entity = this.transform.createTemplatableExpression(StringDataFlowType.TYPE, zendeskEntityOptions.TICKETS);
    }
}
